import { render, staticRenderFns } from "./Wise_contactsbusiness2.vue?vue&type=template&id=ba721828&scoped=true"
import script from "./Wise_contactsbusiness2.vue?vue&type=script&lang=js"
export * from "./Wise_contactsbusiness2.vue?vue&type=script&lang=js"
import style0 from "./Wise_contactsbusiness2.vue?vue&type=style&index=0&id=ba721828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba721828",
  null
  
)

export default component.exports